module.exports = __webpack_public_path__ + "static/media/certified.54d2487d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/enhanced-brand/certified.jpg
// module id = 1196
// module chunks = 0